import { Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SeV2QuestionStatus } from "../../../autogen/bff-api";
import { QUESTION_STATUS_COLORS } from "./questionStatusColors";

export const QuestionStatusBadge = ({ status }: { status: SeV2QuestionStatus }) => {
  const { t } = useTranslation();
  const colors = QUESTION_STATUS_COLORS[status];
  switch (status) {
    case SeV2QuestionStatus.Unanswered:
      return (
        <Badge bg={colors.bg} color={colors.fg}>
          {t("Unanswered")}
        </Badge>
      );
    case SeV2QuestionStatus.Answered:
      return (
        <Badge bg={colors.bg} color={colors.fg}>
          {t("Answered")}
        </Badge>
      );
    case SeV2QuestionStatus.Published:
      return (
        <Badge bg={colors.bg} color={colors.fg}>
          {t("Published")}
        </Badge>
      );
  }
};
